import React, {Fragment, useState} from "react";
import Dictionary from "../../Dictionary";
import InputErrorMessage from "../../InputErrorMessage";
import Validator from "../../../../utils/Validator";
import {isPolishNationality} from "../../../../utils/NationalityUtils";
import BikKrdTooltip from "../BikKrdTooltip";
import FormattedDateInput from "../../../../components/FormattedDateInput/FormattedDateInput";

function PersonFormFields(props) {

    let {formValidator} = props;

    const personChangeHandler = (event) => {
        let {name, value} = event.target;
        props.onChange({...props.person, [name]: value});
    };

    const isDriverLicenceChangeHandler = (event) => {
        let {value} = event.target;
        setIsDriverLicence(value);
    }

    const IDExpirationDateChangeHandler = (date) =>
        props.onChange({...props.person, identityCardExpirationDate: date});

    const birthDateChangeHandler = (date) =>
        props.onChange({...props.person, birthDate: date});

    const driveLicenseExpirationDateChangeHandler = (date) =>
        props.onChange({...props.person, driveLicenseExpirationDate: date});

    const [isDriverLicence, setIsDriverLicence] = useState("");

    const isPESELRequired = () => isPolishNationality(props.person.nationality);
    const isBirthDateRequired = () => !isPolishNationality(props.person.nationality);
    const isDriverLicenceRequired = () => isDriverLicence !== "Nie";

    return (
        <Fragment>
            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="nationality">Obywatelstwo</label>
                <select id="nationality"
                        ref={formValidator.register({required: true})}
                        name="nationality"
                        value={props.person.nationality}
                        onChange={personChangeHandler}>
                    {Dictionary.createDictionaryOptions(Dictionary.ALL_COUNTRIES)}
                </select>
                <InputErrorMessage error={formValidator.errors["nationality"]}/>
            </div>

            {isPESELRequired() && (
                <div className="expert-help-field">
                    <label className="expert-help-label" htmlFor="pesel">PESEL</label>
                    <input type="text"
                           id="pesel"
                           ref={formValidator.register({
                               required: true,
                               pattern: /[0-9]{11}/,
                               maxLength: 11,
                               validate: value => Validator.validatePesel(value)
                           })}
                           name="pesel"
                           value={props.person.pesel}
                           onChange={personChangeHandler}/>
                    <InputErrorMessage error={formValidator.errors["pesel"]}
                                       message="Podaj poprawny numer PESEL"/>
                </div>
            )}

            {isBirthDateRequired() && (
                <div className="expert-help-field">
                    <label className="expert-help-label" htmlFor="birthDate">Data urodzenia</label>
                    <FormattedDateInput
                        name="birthDate"
                        showOnlyPast={true}
                        inputRef={formValidator.register({required: true})}
                        value={props.person.birthDate}
                        onChange={birthDateChangeHandler}
                    />
                    <InputErrorMessage error={formValidator.errors["birthDate"]}
                                       message="Wprowadź poprawną datę w formacie rrrr-mm-dd"/>
                </div>
            )}

            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="firstName">Imię</label>
                <input type="text"
                       id="firstName"
                       ref={formValidator.register({required: true})}
                       name="firstName"
                       value={props.person.firstName}
                       onChange={personChangeHandler}/>
                <InputErrorMessage error={formValidator.errors["firstName"]}/>
            </div>

            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="lastName">Nazwisko</label>
                <input type="text"
                       id="lastName"
                       ref={formValidator.register({required: true})}
                       name="lastName"
                       value={props.person.lastName}
                       onChange={personChangeHandler}/>
                <InputErrorMessage error={formValidator.errors["lastName"]}/>
            </div>

            <div className="expert-help-field">
                <BikKrdTooltip>
                    <label className="expert-help-label" htmlFor="bikStatus">Status w bazach BIK/KRD</label>
                </BikKrdTooltip>
                <select id="bikStatus"
                        ref={formValidator.register({required: true})}
                        name="bikStatus"
                        value={props.person.bikStatus === null ? "" : props.person.bikStatus}
                        onChange={personChangeHandler}>
                    <option value=""></option>
                    {Dictionary.createDictionaryOptionsValueAsKey(Dictionary.BIK_KRD_STATUS)}
                </select>
                <InputErrorMessage error={formValidator.errors.bikStatus}/>
            </div>

            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="identityCardType">Rodzaj dowodu tożsamości</label>
                <select id="identityCardType"
                        ref={formValidator.register({required: true})}
                        name="identityCardType"
                        value={props.person.identityCardType}
                        onChange={personChangeHandler}>
                    {Dictionary.createDictionaryOptionsValueAsKey(Dictionary.IDENTITY_CARD_TYPE)}
                </select>
                <InputErrorMessage error={formValidator.errors["identityCardType"]}/>
            </div>

            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="identityCardNumber">Nr dowodu tożsamości</label>
                <input type="text"
                       id="identityCardNumber"
                       ref={formValidator.register({required: true})}
                       name="identityCardNumber"
                       value={props.person.identityCardNumber}
                       onChange={personChangeHandler}/>
                <InputErrorMessage error={formValidator.errors["identityCardNumber"]}/>
            </div>

            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="identityCardExpirationDate">Data ważności dowodu tożsamości</label>
                <FormattedDateInput
                    name="identityCardExpirationDate"
                    showOnlyFuture={true}
                    inputRef={formValidator.register({required: true})}
                    value={props.person.identityCardExpirationDate}
                    onChange={IDExpirationDateChangeHandler}
                />
                <InputErrorMessage error={formValidator.errors["identityCardExpirationDate"]}
                                   message="Wprowadź poprawną datę w formacie rrrr-mm-dd"/>
            </div>

            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="identityCardAuthority">Organ wydający dowód tożsamości</label>
                <input type="text"
                       id="identityCardAuthority"
                       ref={formValidator.register({required: true})}
                       name="identityCardAuthority"
                       value={props.person.identityCardAuthority}
                       onChange={personChangeHandler}/>
                <InputErrorMessage error={formValidator.errors["identityCardAuthority"]}/>
            </div>

            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="isDriverLicence">Prawo jazdy</label>
                <select id="isDriverLicence"
                        ref={formValidator.register({required: true})}
                        name="isDriverLicence"
                        value={isDriverLicence}
                        onChange={isDriverLicenceChangeHandler}>
                    {Dictionary.createDictionaryOptionsValueAsKey(Dictionary.IS_DRIVING_LICENCE)}
                </select>
                <InputErrorMessage error={formValidator.errors.isDriverLicence}/>
            </div>

            {isDriverLicenceRequired() && (
                <div className="expert-help-field">
                    <label className="expert-help-label" htmlFor="driveLicenseNumber">Nr prawa jazdy</label>
                    <input type="text"
                           id="driveLicenseNumber"
                           ref={formValidator.register({required: true})}
                           name="driveLicenseNumber"
                           value={props.person.driveLicenseNumber}
                           onChange={personChangeHandler}/>
                    <InputErrorMessage error={formValidator.errors.driveLicenseNumber}/>
                </div>
            )}

            {isDriverLicenceRequired() && (
                <div className="expert-help-field">
                    <label className="expert-help-label" htmlFor="driveLicenseExpirationDate">Data ważności prawa jazdy</label>
                    <FormattedDateInput
                        name="driveLicenseExpirationDate"
                        inputRef={formValidator.register({required: true})}
                        showOnlyFuture={true}
                        value={props.person.driveLicenseExpirationDate}
                        onChange={driveLicenseExpirationDateChangeHandler}
                    />
                    <InputErrorMessage error={formValidator.errors["driveLicenseExpirationDate"]}
                                       message="Wprowadź poprawną datę w formacie rrrr-mm-dd"/>
                </div>
            )}

            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="phoneNumber">Nr telefonu</label>
                <input type="text"
                       id="phoneNumber"
                       ref={formValidator.register({
                           required: true,
                           pattern: /[0-9]{9}/,
                           maxLength: 9
                       })}
                       name="phoneNumber"
                       value={props.person.phoneNumber}
                       onChange={personChangeHandler}
                       placeholder="Np. 753421869 (9 cyfr)"/>
                <InputErrorMessage error={formValidator.errors["phoneNumber"]}
                                   message="Podaj poprawny numer telefonu (9 cyfr)"/>
            </div>

            <div className="expert-help-field">
                <label className="expert-help-label" htmlFor="email">Adres e-mail</label>
                <input type="email"
                       id="email"
                       ref={formValidator.register({required: true})}
                       name="email"
                       value={props.person.email}
                       onChange={personChangeHandler}/>
                <InputErrorMessage error={formValidator.errors["email"]}
                                   message="Podaj poprawny adres e-mail"/>
            </div>
        </Fragment>
    );
}

export default PersonFormFields;
